// this.$store.state.planAccion
import { db } from "@/firebase";
import {
  doc,
  query,
  collection,
  where,
  getDocs,
  serverTimestamp,
  setDoc,
  updateDoc,
  limit,
  orderBy,
} from "firebase/firestore";
import moment from "moment";
import { colecciones } from "../constantes";

// PLAN DE ACCIÓN
export const planAccion = {
  registro: {
    objeto: class {
      constructor() {
        return {
          id: "",
          idEmpresa: "",
          nombre: "",
          descripcion: "",
          objetivos: [],
          anexos: [],
          registro: {
            idUsuario: "",
            tipo: "Manual",
            estado: "Creado",
            creacion: serverTimestamp(),
            actualizacion: serverTimestamp(),
            filtro: moment().format("YYYY-MM-DD"),
          },
        };
      }
    },
    funciones: {
      async crear(planAccion) {
        await setDoc(
          doc(
            db,
            colecciones.firebase.empresa.planesAccion.registros,
            planAccion.id,
          ),
          planAccion,
        );
      },
      async actualizar(planAccion) {
        await updateDoc(
          doc(
            db,
            colecciones.firebase.empresa.planesAccion.registros,
            planAccion.id,
          ),
          {
            nombre: planAccion.nombre,
            descripcion: planAccion.descripcion,
            objetivos: planAccion.objetivos,
            anexos: planAccion.anexos,
            "registro.estado": "Editado",
            "registro.actualizacion": serverTimestamp(),
          },
        );
      },
      async eliminar(id) {
        await updateDoc(
          doc(db, colecciones.firebase.empresa.planesAccion.registros, id),
          {
            "registro.estado": "Eliminado",
            "registro.actualizacion": serverTimestamp(),
          },
        );
      },
      async obtener(id) {
        const q = query(
          collection(
            db,
            colecciones.firebase.empresa.planesAccion.registros,
          ),
          where("id", "==", id),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
      },
      async generarID() {
        const refPlanAccion = doc(
          collection(
            db,
            colecciones.firebase.empresa.planesAccion.registros,
          ),
        );
        return refPlanAccion.id;
      },
      async obtenerUltimo(idEmpresa) {
        const q = query(
          collection(
            db,
            colecciones.firebase.empresa.planesAccion.registros,
          ),
          where("idEmpresa", "==", idEmpresa),
          where("registro.estado", "in", ["Creado", "Editado"]),
          orderBy("registro.creacion", "desc"),
          limit(1),
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
      },
    },
  },
  actividad: {
    objeto: class {
      constructor() {
        return {
          id: "",
          idPlanAccion: "",
          idEmpresa: "",
          nombre: "",
          descripcion: "",
          responsables: [],
          recursos: [],
          estado: "Pendiente", // PENDIENTE, ABIERTA, CERRADA
          tipo: "", // CORRECTIVA, PREVENTIVA, MEJORA, OBSERVACIÓN
          origen: {
            id: "",
            coleccion: "",
            modulo: "", // SEGURIDAD VIAL - CONDUCTORES, VEHÍCULOS, INSPECCIONES, PLANES DE DESPLAZAMIENTOS, ETC.
            categoria: "", // DOCUMENTAL, SINIESTRALIDAD, OPERACIONAL, MANTENIMIENTO, CAPACITACIÓN, AUDITORÍA
          },
          fechas: {
            hallazgo: "",
            limite: "",
            cierre: "",
          },
          registro: {
            idUsuario: "",
            tipo: "Manual",
            estado: "Creado",
            creacion: serverTimestamp(),
            actualizacion: serverTimestamp(),
            filtro: moment().format("YYYY-MM-DD"),
            apertura: {
              idUsuario: "",
              fecha: "",
              evidencias: [],
              observaciones: "",
              filtro: "",
            },
            cierre: {
              idUsuario: "",
              fecha: "",
              evidencias: [],
              enlaceSolucion: "",
              observaciones: "",
              filtro: "",
            },
            verificacion: {
              idUsuario: "",
              fecha: "",
              estado: "Pendiente", // PENDIENTE, VERIFICADA
              cumple: "", // SI, NO
              evidencias: [],
              observaciones: "",
              filtro: "",
            },
          },
        };
      }
    },
    funciones: {
      async crear(actividad) {
        actividad.registro.creacion = serverTimestamp();
        actividad.registro.actualizacion = serverTimestamp();
        await setDoc(
          doc(
            db,
            colecciones.firebase.empresa.planesAccion.actividades.registros,
            actividad.id,
          ),
          actividad,
        );
      },
      async actualizar(actividad) {
        await updateDoc(
          doc(
            db,
            colecciones.firebase.empresa.planesAccion.actividades.registros,
            actividad.id,
          ),
          {
            nombre: actividad.nombre,
            descripcion: actividad.descripcion,
            responsables: actividad.responsables,
            recursos: actividad.recursos,
            tipo: actividad.tipo,
            origen: actividad.origen,
            fechas: actividad.fechas,
            estado: actividad.estado,
            "registro.estado": "Editado",
            "registro.actualizacion": serverTimestamp(),
            "registro.apertura": actividad.registro.apertura,
            "registro.cierre": actividad.registro.cierre,
            "registro.verificacion": actividad.registro.verificacion,
          },
        );
      },
      async eliminar(id) {
        await updateDoc(
          doc(
            db,
            colecciones.firebase.empresa.planesAccion.actividades.registros,
            id,
          ),
          {
            "registro.estado": "Eliminado",
            "registro.actualizacion": serverTimestamp(),
          },
        );
      },
      async obtener(id) {
        const q = query(
          collection(
            db,
            colecciones.firebase.empresa.planesAccion.actividades.registros,
          ),
          where("id", "==", id),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
      },
      async generarID() {
        const refActividad = doc(
          collection(
            db,
            colecciones.firebase.empresa.planesAccion.actividades.registros,
          ),
        );
        return refActividad.id;
      },
      async obtenerRegistrosPlan(idPlanAccion) {
        const q = query(
          collection(
            db,
            colecciones.firebase.empresa.planesAccion.actividades.registros,
          ),
          where("idPlanAccion", "==", idPlanAccion),
          where("registro.estado", "in", ["Creado", "Editado"]),
          orderBy("registro.creacion", "asc"),
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.length > 0
          ? querySnapshot.docs.map((doc) => doc.data())
          : [];
      },
      async obtenerCantidadResponsable(idEmpresa, idUsuario) {
        const q = query(
          collection(
            db,
            colecciones.firebase.empresa.planesAccion.actividades.registros,
          ),
          where("idEmpresa", "==", idEmpresa),
          where("responsables", "array-contains", idUsuario),
          where("estado", "==", "Abierta"),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.length > 0
          ? querySnapshot.docs.length
          : 0;
      },
    },
  },
};
